module.exports = __webpack_public_path__ + "static/media/artist.69f35ad7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/introduction/assets/artist.jpg
// module id = 204
// module chunks = 0